import exceptionIcon from '@jetbrains/icons/exception.svg?react'
import {lazy, Suspense} from 'react'
import {useRouteError} from 'react-router'

import {extractErrorFromRelay} from '../../../relay/extractErrorFromRelay'
import {getPipelinesHref} from '../../../routes'
import getErrorStatusCode from '../../../utils/getErrorStatusCode'
import PageNotFound from '../../common/PageNotFound/PageNotFound'
import RouterLink from '../../common/RouterLink/RouterLink'

import FullScreenErrorWrapper from './components/FullScreenErrorWrapper/FullScreenErrorWrapper'
import {HTTPCodes} from './types'
import {serializeError} from './utils/error'

const ErrorMessage = lazy(
  () =>
    import(
      /* webpackChunkName: "ErrorMessage" */ '@jetbrains/ring-ui-built/components/error-message/error-message'
    ),
)

export default function PipelinesPagesErrorBoundary() {
  const routeError = useRouteError() as Error | null | undefined
  const error = routeError && extractErrorFromRelay(routeError)
  const errorStatusCode = getErrorStatusCode(error)
  const is404Error = errorStatusCode === HTTPCodes.NOT_FOUND

  return (
    <FullScreenErrorWrapper>
      {is404Error ? (
        <PageNotFound message={error?.message} />
      ) : (
        <Suspense>
          <ErrorMessage
            icon={exceptionIcon}
            message="Error while loading data"
            description={serializeError(error)}
          >
            <RouterLink to={getPipelinesHref()}>{'Go to the home page'}</RouterLink>
          </ErrorMessage>
        </Suspense>
      )}
    </FullScreenErrorWrapper>
  )
}
